var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BFormInput',{staticClass:"form-input-number-onboarding",attrs:{"type":"number","inputmode":"decimal","pattern":"[0-9]*","min":"1","placeholder":"0","size":"lg","block":"","formatter":_vm.formatter},model:{value:(_vm.valueComputed),callback:function ($$v) {_vm.valueComputed=$$v},expression:"valueComputed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }